(function() {
    'use strict';

    angular
        .module('quantixApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', '$state', '$stateParams','$http','$window','Account','$uibModal'];

    function HomeController ($scope, Principal, $state, $stateParams,$http,$window,Account,$uibModal) {

    	//$rootScope.homePageMenuStatus=false;
    	$scope.account = null;
    	$scope.isAuthenticated = null;
    	$scope.modulename = $stateParams.modulename;
    	$scope.companyCode = $stateParams.companyCode;
    	$scope.companyName = $stateParams.companyName;
    	$scope.portfolioId = $stateParams.portfolioId;
    	$scope.portfolioName = $stateParams.portfolioName;
    	$scope.portfolioType= $stateParams.portfolioType;
    	$scope.portfolioType= $stateParams.portfolioType;
    	$scope.portfolioDateTime=$stateParams.portfolioDateTime;
    	 checkUserLogInStatus();
    	

        $scope.$on('authenticationSuccess', function() {
        	$scope.getAccount();
        });
        $scope.getBack=function(){
        	$state.go('companyDetails', {
				'companyCode' :  $scope.companyCode,
				'companyName' :  $scope.companyName
			})
        }
        

        $scope.getBackToPortfolio=function(){
        	$state.go('portfolioLanding', {
				'portfolioId' : $scope.portfolioId,
				'portfolioName' : $scope.portfolioName,
				'portfolioType' : $scope.portfolioType,
				'portfolioDateTime':$scope.portfolioDateTime
			});
        }
		

		//added for temporary terms and condition pop up
		//shubham todo: remove after next release
		var showTC= true;
		
		var istermsviewed = $window.localStorage['istermsviewed']
		var value = "true";
		JSON.parse(istermsviewed) === true; // true


		if (JSON.parse(istermsviewed) === true) {
			//do nothing dont show modal popup here
			$('#commentSection').hide();
		} else {
			//show modal popup



			angular.element(document).ready(function () {
				showTC = true;
				$('#commentSection').show();
				showTC = false;
			});
		}


		$scope.closeUpdatedTermsModal = function() {
			$('#commentSection').hide();
			$window.localStorage['istermsviewed']=JSON.stringify(true); 

		}

        $scope.getAccount = function() {
            Principal.identity().then(function(account) {
            	$scope.account = account;
            	$scope.isAuthenticated = Principal.isAuthenticated;
                if(account == null){
                	$state.go('login');
                }
            });
        }
        $scope.register = function() {
            $state.go('register');
        }

        $scope.newsList = [
                                {
                                  title: 'Powered by data on 30,000+ companies, covering over 190 industries and 500 districts and cities'
                                },
                                {
                                  title: 'Carefully designed tools based on CRISIL’s rich experience & understanding of market needs'

                                },
                                {
                                    title: 'Fulfilling needs across diverse functions – client origination, credit/investment underwriting, credit monitoring & risk management, and treasury'

                                }
                             ];

        $scope.getAccount();
        
        function getAlldropdownData() {
        	var locationtreedata = null;
        	var producttreedata = null;
        	//for lcoation
        	$http.post('api/masterData/getZonalLocationTreeList').then(function(response) {
        		
        		locationtreedata = response.data;
        		$window.localStorage['locationtreedata']=JSON.stringify(locationtreedata);
        		}, function(errResponse) {

			});
        	
        	$http.post('api/masterData/getMasterProductTreeData').then(function(response) {
        		
        		producttreedata = response.data;
        		$window.localStorage['producttreedata']=JSON.stringify(producttreedata);
        		}, function(errResponse) {

			});
        	
        	
        	
        	
        }
        
        getAlldropdownData();
        
	// code added for checking weather user login first time or not
		
		function checkUserLogInStatus() {
			
			Account.get().$promise.then(function(response) {
				
				$scope.data = response.data;
				if($scope.data.isFirstLogin == 1){

					$scope.openPopUpForFirstLoginUser();
				}
			})
		}
		
		$scope.openPopUpForFirstLoginUser = function(){
			
			 $uibModal.open({
        		 templateUrl: 'app/components/login/loginFirstTime.html',
        		 scope : $scope,
        		 controller :'FirstTimeLoginController',
        		 controllerAs: 'vm',
        		 size: 'lg',
        		 backdrop: 'static' 
        		 });
		}
		// end here
    }
})();
